import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { fontSize, fontWeight, spacing } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/products/utils/domain/intl'

interface AttributeOverrideSuccessProps {}

const Container = styled.div({
  display: 'flex',
  flex: 1,
  marginTop: spacing.X12,
  fontSize: fontSize.X18,
  fontWeight: fontWeight.MEDIUM,
  fontStyle: 'italic',
})

export const AttributeOverrideSuccess: FunctionComponent<AttributeOverrideSuccessProps> = () => {
  const messages = useDomainMessages({
    success: 'productsDomain.attributeOverride.success.message',
  })
  return <Container>{messages.success}</Container>
}
